import {ParlayStatus, ParlayType} from "../../../constants/PickXEnums";
import {getError} from "../../../constants/ErrorCodes";

export const handleSubmitParlayRejected = (state, action) => {
    state.placingParlayState.status = 'error';
    state.placingParlayState.error = getError(action.payload);
}

export const handleParlayPlaced = (state, action) => {
    const {ParlayId, CorrelationId, AccountId, Label, DateCreated, Parlay} = action.payload;
    const index = state.userParlays.findIndex(p => p.Id === CorrelationId);
    if (index !== -1) {
        const parlay = state.userParlays[index];
        state.placingParlayState.lastPlacedParlay = {...parlay};
        state.userParlays[index] = Parlay;
        state.selectedParlayId = ParlayId
        state.placingParlayState.error = null;
        state.placingParlayState.status = 'success';
        state.placingParlayState.placedParlayId = ParlayId;
    }
}

export const handlePlaceParlayFailed = (state, action) => {
    state.placingParlayState.status = 'error';
    state.placingParlayState.error = getError(action.payload);
}

export const handleParlayResultsChanged = (state, action) => {
    const {ParlayId, Changes} = action.payload;
    const index = state.userParlays.findIndex(p => p.Id === ParlayId);
    if (index !== -1) {
        Changes.forEach(c=>{
            state.userParlays[index].ContestsPicks[c.Name].Result = c.newValue;
        })
    }
}

export const handleParlayCancelled = (state, action) => {
    const {ParlayId, Reason} = action.payload;
    const index = state.userParlays.findIndex(p => p.Id === ParlayId);
    if (index !== -1) {
        state.userParlays[index].Status = ParlayStatus.Cancelled;
        state.userParlays[index].CancellationReason = Reason;
    }
}

export const handleParlayCompleted = (state, action) => {
    const {ParlayId} = action.payload;
    const index = state.userParlays.findIndex(p => p.Id === ParlayId);
    if (index !== -1) {
        state.userParlays[index].Status = ParlayStatus.Completed;
        state.userParlays[index].Payout = action.payload.Payout;
    }
}